import { Translation } from 'hooks/useTranslation/useTranslation';
import { PageTabItems } from 'v2/components/PageTabs/PageTabs';
import { areCloudControllersEnabled } from 'v2/utils/areCloudControllersEnabled';

export const createDeviceTabs = (translation: Translation): PageTabItems => [
  {
    text: translation.all_devices,
    path: '/devices/overview'
  },
  ...(areCloudControllersEnabled()
    ? [
        {
          text: translation.cloud_controllers,
          path: '/devices/cloud-controllers'
        }
      ]
    : []),
  {
    text: translation.device_groups,
    path: '/devices/groups'
  }
];
